export class HeaderSearch {
	private element: HTMLElement;
	private openButtonElement: HTMLButtonElement;
	private closeButtonElement: HTMLButtonElement;
	private activeClass: string = 'header-search--active';

	constructor(element) {
		if (!element) return;

		this.element = element;
		this.openButtonElement = this.element.querySelector('.header-search__button');
		this.closeButtonElement = this.element.querySelector('.header-search__close');

		this.init();
	}

	public open = (): void => this.element.classList.add(this.activeClass);

	public close = (): void => {
		this.element.classList.remove(this.activeClass);
		window.app?.headerSearchResult.close();
	};

	private handleClick = ({ target }): void => {
		if (this.openButtonElement.contains(target)) this.open();
		else if (this.closeButtonElement.contains(target)) this.close();
	};

	public init = (): void => {
		this.element.addEventListener('click', this.handleClick);
	};
}
